import { render, staticRenderFns } from "./UsageChallengeList.vue?vue&type=template&id=6bbf201e&scoped=true&"
import script from "./UsageChallengeList.vue?vue&type=script&lang=js&"
export * from "./UsageChallengeList.vue?vue&type=script&lang=js&"
import style0 from "./UsageChallengeList.vue?vue&type=style&index=0&id=6bbf201e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf201e",
  null
  
)

export default component.exports